import React, { useState } from "react";
import { addProduct } from "../../firebaseService";
const ProductForm = () => {
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!productName || !price || !description || !imageFile) {
      alert("모든 필드를 입력해주세요!");
      return;
    }

    setLoading(true);
    const result = await addProduct(productName, price, description, imageFile);
    setLoading(false);

    if (result.success) {
      alert("상품이 성공적으로 추가되었습니다!");
      setProductName("");
      setPrice("");
      setDescription("");
      setImageFile(null);
    } else {
      alert("상품 추가 실패: " + result.error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "400px",
        margin: "auto",
      }}
    >
      <input
        type="text"
        placeholder="상품명"
        value={productName}
        onChange={(e) => setProductName(e.target.value)}
        required
      />
      <input
        type="number"
        placeholder="가격"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        required
      />
      <textarea
        placeholder="상세 설명"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required
      />
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files[0])}
        required
      />
      <button type="submit" disabled={loading}>
        {loading ? "추가 중..." : "상품 추가"}
      </button>
    </form>
  );
};

export default ProductForm;
